/* Terraloo Sleek — collection sort auto-submit */
(function () {
  'use strict';

  var sortSelect = document.querySelector('[data-tls-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }
})();
